import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { WhoppahCourierFast } from "@/assets/icons/24/WhoppahCourierFast";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { ProductDeliveryOptionItemProps } from "@/features/product-delivery-options/components/ProductDeliveryOptionItem";
import { ProductDeliveryOptionItemRow } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemRow";
import { getProductDeliveryPriceLabel } from "@/features/product-delivery-options/components/utils/product-delivery-options.utils";
import { useProductDeliveryEstimateLabel } from "@/features/product-delivery-options/hooks/useProductDeliveryEstimateLabel";
import { showModal } from "@/ui/Modal2";

export const ProductDeliveryOptionItemCourier = ({
  option,
  loading,
}: ProductDeliveryOptionItemProps) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const estimate = useProductDeliveryEstimateLabel(option);
  const { label, isFree } = getProductDeliveryPriceLabel(option, t, locale);

  const handleReadMoreClick = () => {
    showModal("pdp-details-modal", {
      title: t("shipping-options:product-shipping-option-courier-title"),
      text: t("shipping-options:product-shipping-option-courier-body"),
    });

    /** Trigger `readmore_courier_pdp` event. */
    analyticsService.trackReadMoreCourierPdp();
  };

  return (
    <ProductDeliveryOptionItemRow
      method="courier"
      icon={<WhoppahCourierFast className="size-6 shrink-0 text-brand-500" />}
      // ponytail: placeholder key for new copy "Delivery by Whoppah's partners"
      title={t("pdp:pdp-usp-shipping-title-courier-v2")}
      subtitle={estimate}
      priceLabel={label}
      isFree={isFree}
      loading={loading}
      onInfoClick={handleReadMoreClick}
    />
  );
};
